import { Box, Button, useTheme } from '@mui/material';
import { FiPlus } from 'react-icons/fi';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const NoCollections = (props) => {
    const theme = useTheme();
    const { t } = useTranslation();

    const containerVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                staggerChildren: 0.2
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 10 },
        visible: { opacity: 1, y: 0 }
    };

    return (
        <motion.div
            initial="hidden"
            animate="visible"
            variants={containerVariants}
            style={{
                backgroundColor: '#fff',
                border: '1px solid #E4EBF6',
                borderRadius: '16px',
                padding: props.windowWidth > 900 ? '40px 0px' : '20px 0px',
                margin: props.windowWidth > 900 ? '0px 0px' : '20px',
                overflow: 'hidden'
            }}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: props.windowWidth > 900 ? '40px 20px' : '40px 20px',
                    textAlign: "center",
                    background: 'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(247,249,252,0.4) 100%)',
                }}
            >
                <motion.div
                    variants={itemVariants}
                    style={{
                        padding: '24px 24px',
                        textAlign: 'center',
                        borderRadius: '12px',
                        maxWidth: '600px'
                    }}>
                    <motion.div
                        initial={{ scale: 0.5, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ duration: 0.5 }}
                        style={{
                            fontSize: '56px',
                            marginBottom: '16px',
                            filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))'
                        }}>
                        📚
                    </motion.div>
                    
                    <motion.h2
                        variants={itemVariants}
                        style={{
                            margin: '0',
                            fontSize: '24px',
                            fontWeight: '700',
                            color: '#1D1D1D',
                            fontFamily: 'Roboto, sans-serif',
                            marginBottom: '12px',
                            letterSpacing: '-0.5px'
                        }}>
                        {t('dashboard.subscriptions.createFirstCollection')}
                    </motion.h2>
                    
                    <motion.p
                        variants={itemVariants}
                        style={{
                            fontSize: '16px',
                            color: '#6E7787',
                            fontWeight: '400',
                            textAlign: 'center',
                            margin: '0 auto 40px',
                            maxWidth: '500px',
                            fontFamily: 'Roboto, sans-serif',
                            lineHeight: '1.6'
                        }}>
                        {t('dashboard.subscriptions.organizeCollectionsDesc')}
                    </motion.p>

                    <motion.div
                        variants={itemVariants}>
                        <Button
                            disableElevation
                            disabled={props.disabled}
                            sx={{
                                backgroundColor: props.disabled ? '#E0E0E0' : 'var(--brand-color)',
                                color: props.disabled ? '#9E9E9E' : 'white',
                                fontSize: '16px',
                                fontWeight: '600',
                                width: '100%',
                                maxWidth: '300px',
                                height: '60px',
                                margin: '0 auto 40px auto',
                                borderRadius: '100px',
                                textTransform: 'none',
                                cursor: props.disabled ? 'not-allowed' : 'pointer',
                                transition: 'all 0.3s ease',
                                ':hover': {
                                    backgroundColor: props.disabled ? '#E0E0E0' : 'var(--brand-color)',
                                    transform: props.disabled ? 'none' : 'translateY(-1px)',
                                }
                            }}
                            onClick={() => {
                                if (!props.disabled) {
                                    props.buttonAction()
                                }
                            }}
                            variant='contained'
                        >
                            <FiPlus style={{ marginRight: '8px', color: props.disabled ? '#9E9E9E' : '#fff', strokeWidth: '2.5', fontSize: '20px' }} />
                            {props.disabled ? t('checkout.subscriptionRequired') : t('content.edit.createCollection')}
                        </Button>
                    </motion.div>

                    {/* <motion.p
                        variants={itemVariants}
                        style={{
                            fontSize: '14px',
                            color: '#6E7787',
                            fontWeight: '400',
                            textAlign: 'center',
                            margin: '0',
                            fontFamily: 'Roboto, sans-serif'
                        }}>
                        Need help getting started?{' '}
                        <a
                            href={'https://help.withme.so/en/collections/8546931-growing-your-audience'}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                color: '#3B55F3',
                                textDecoration: 'none',
                                fontWeight: '500',
                                transition: 'all 0.2s ease',
                                ':hover': {
                                    textDecoration: 'underline'
                                }
                            }}>
                            Learn about collections
                        </a>
                    </motion.p> */}
                </motion.div>
            </Box>
        </motion.div>
    );
};

export default NoCollections;
